import React, { Component } from "react"
import PropTypes from "prop-types"
import { FormStyle } from "./form-style"
import { useFormInfo, useEditingContext } from "app/forms/data/form-data"
import classNames from "classnames"

export const Form = ({ style, children, ...props }) => {
  const editing = useEditingContext()
  const {
    action,
    id,
    uid,
    template: { format },
    ckjsVersion
  } = useFormInfo()

  const Tag = editing ? "div" : "form"
  const className = classNames(props.className, "formkit-form")

  return (
    <Tag
      action={action}
      style={style}
      className={className}
      method="post"
      data-sv-form={id}
      data-uid={uid}
      data-format={format}
      data-version={ckjsVersion}
    >
      {children}
    </Tag>
  )
}

export class LandingPage extends Component {
  static propTypes = {
    children: PropTypes.any,
    settings: PropTypes.object,
    style: PropTypes.object,
    template: PropTypes.func,
    uid: PropTypes.string
  }

  render() {
    return (
      <div
        className="seva-page formkit-page"
        style={this.props.style}
        data-uid={this.props.uid}
      >
        {this.props.children}
        <style>
          {/* imports the shared.css stylesheet into the legacy layer, to prevent precedence issues with tailwind.
              Legacy layer is defined as the lowest one */}
          {`@import "https://pages.convertkit.com/templates/shared.css" layer(legacy);`}
        </style>
        <FormStyle
          scope={`.formkit-page[data-uid="${this.props.uid}"]`}
          settings={this.props.settings}
          template={this.props.template}
        />
      </div>
    )
  }
}
